import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import GenericApplicationCard from 'portfolio3/features/pdf/components/cards/GenericApplicationCard';
import { IndustrySpecialityList } from 'portfolio3/features/proforientation/components/specialities';
import { ApplicationDodMappedData } from 'portfolio3/features/proforientation/model/selectors/applications';
import { activeFormatSelector } from 'selectors/drawers';

import SpecialityContainer from '../proforientation/SpecialityContainer';

type ApplicationOpenDaysProps = {
  data: ApplicationDodMappedData[];
};

const ApplicationOpenDays = ({ data }: ApplicationOpenDaysProps) => {
  const format = useAppSelector(activeFormatSelector);

  return (
    <Box className="application-open-day">
      <Typography variant="Headings/H5">Дни открытых дверей</Typography>
      <Box marginTop="16px" className="application-open-day__content">
        <Box display="grid" gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'} gap="16px">
          {data.map((entity) => {
            return (
              <GenericApplicationCard
                key={entity.eventId}
                date={entity.formattedDate}
                industry={entity.industry}
                name={entity.name}
                place={entity.place}
                statusApplicationCode={entity.statusApplication}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default ApplicationOpenDays;
